module.exports = __webpack_public_path__ + "img/infoBlack.26118515.gif";